import { useContext } from "react";
import { context } from "utils/Provider";
import { useInitTableForAzureMutation, useInitTableForMatcherDataMutation } from "graphql/types/graphql";
import { enqueueSnackbar } from "notistack";

interface UseTableInitializerProps {
  onFileUpload?: (file: File, headers: string[]) => Promise<void>;
}

export function useTableInitializer({ onFileUpload }: UseTableInitializerProps = {}) {
  const { selectedCube } = useContext(context);
  const [initTableForAzure] = useInitTableForAzureMutation();
  const [initTableForMatcherData] = useInitTableForMatcherDataMutation();

  const initializeTable = async (file: File, headers: string[], mutationType: "azure" | "matcher") => {
    try {
      if (mutationType === "azure") {
        await initTableForAzure({
          variables: {
            cubeName: selectedCube?.name,
            headers,
          },
        });
      } else {
        await initTableForMatcherData({
          variables: {
            headers,
          },
        });
      }
      await onFileUpload?.(file, headers);
      // enqueueSnackbar("Table initialized successfully", { variant: "success", autoHideDuration: 3000 });
    } catch (error) {
      enqueueSnackbar(
        `Failed to initialize table: ${(error instanceof Error && error.message) || "Something went wrong"}`,
        { variant: "error", autoHideDuration: 5000 }
      );
    }
  };

  return { initializeTable };
}
